module.exports = __webpack_public_path__ + "static/media/S (50).cea01d2e.jpg";